import { PortalTelemetryScreen } from '../../app/telemetry/portalTelemetryScreens';
import { portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { Box, Paper, Grid, Typography } from '@mui/material';
import InGoodStanding from './InGoodStanding';
import NotInGoodStanding from './NotInGoodStanding';
import { useMsal } from '@azure/msal-react';
import { IdTokenClaims } from '../../app/models/account/idTokenClaims';

export default function MemberInGoodStanding() {

  const { instance } = useMsal();
  const userClaims = instance.getActiveAccount()?.idTokenClaims as unknown as IdTokenClaims;

  usePortalScreen(portalScreenContext(PortalTelemetryScreen.MemberInGoodStanding), undefined, true);

  return <>
    <Box sx={{ minWidth: "100%" }} component={Paper}>
      <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

        <Grid size={{ xs: 12 }}></Grid>

        <Grid size={{ xs: 12 }}>
          <Typography variant='h4'>RCSI Letter of Good Standing</Typography>
        </Grid>

        {userClaims?.extension_portalcrm_famIGS === true &&
          <Grid size={{ xs: 12 }} sx={{ marginRight: '3%' }}>
            <InGoodStanding />
          </Grid>
        }

        {userClaims?.extension_portalcrm_famIGS === false &&
          <Grid size={{ xs: 12 }} sx={{ marginRight: '3%' }}>
            <NotInGoodStanding />
          </Grid>
        }

        <Grid size={{ xs: 12 }}></Grid>

      </Grid>
    </Box>
  </>
}